import { render } from "./ActiveFiltersBar.vue?vue&type=template&id=c26f4856&scoped=true"
import script from "./ActiveFiltersBar.vue?vue&type=script&lang=js"
export * from "./ActiveFiltersBar.vue?vue&type=script&lang=js"

import "./ActiveFiltersBar.vue?vue&type=style&index=0&id=c26f4856&scoped=true&lang=scss"

import exportComponent from "/srv/ewigo-local-code/minisite/releases/20261028142212-afc99f34de38fbb8c9a48d510159883af3f0ac39/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c26f4856"]])

export default __exports__